var _rect, _path, _rect2, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiFidUnlimited = function SvgMultiFidUnlimited(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18.913,
    height: 13.833,
    fill: "#D7B97C",
    rx: 1,
    transform: "matrix(.96276 -.27035 .2843 .95874 0 5.613)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "M10.673 9.805c1.433 2.64 1.15 3.907 1.059 4.486.388-.986.793-3.072-.183-4.87-1.279-2.355-1.327-3.505-1.138-4.337-.855 2.278-.237 3.802.262 4.721",
    clipRule: "evenodd"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 18.949,
    height: 13.805,
    x: 6,
    y: 9.613,
    fill: "#000",
    rx: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F2F2F2",
    fillRule: "evenodd",
    d: "M15.11 16.716c.624 2.923-.01 4.065-.262 4.596.654-.843 1.637-2.737 1.212-4.728-.558-2.609-.276-3.726.142-4.475-1.47 1.958-1.31 3.59-1.093 4.607",
    clipRule: "evenodd"
  })));
};
export default SvgMultiFidUnlimited;